<template>
  <span class="inline-flex">
    <!-- tao moi -->
    <i
      v-if="isRead === READ_STATUS.UN_READ"
      class="font-size__medium far fa-eye-slash color__green icon-status "
    ></i>
    <!-- dang trinh ky -->
    <i
      v-else-if="isRead === READ_STATUS.READED"
      class="font-size__medium far fa-eye  color__cyan icon-status "
    ></i>
    <i
      v-else
      class="font-size__medium far fa-eye  color__silver icon-status "
    ></i>
  </span>
</template>

<script>
  import constants from "../../constants";

  export default {
    name: "filterIconIsReadVban",
    props: ['isRead'],
    data() {
      return {
        READ_STATUS: constants.READ_STATUS
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/common/filterIconIsReadVban.vue